"use client";
import { useRef, useState } from "react";
import { Button, Input, Label } from "@govio/ui";
export function RegistrationForm() {
  const [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [error, setError] = useState("");
  const lock = useRef(false);
  const requestId = useRef<string | null>(null);
  return (
    <form
      className="mt-4 space-y-3"
      onSubmit={(event) => {
        void (async () => {
          event.preventDefault();
          if (lock.current) return;
          lock.current = true;
          setBusy(true);
          setError("");
          const form = new FormData(event.currentTarget);
          requestId.current ??= crypto.randomUUID();
          try {
            const r = await fetch("/api/public/municipal-registration", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              signal: AbortSignal.timeout(20000),
              body: JSON.stringify({
                requestId: requestId.current,
                name: form.get("name"),
                email: form.get("email"),
                password: form.get("password"),
                confirmPassword: form.get("confirmPassword"),
                consent: form.get("consent") === "on",
              }),
            });
            const raw: unknown = await r.json();
            const body = raw as { data?: { message?: string }; error?: string };
            if (!r.ok)
              throw Error(
                body.error ??
                  "Não foi possível registrar. Tente novamente com os mesmos dados.",
              );
            setMessage(
              body.data?.message ?? "Solicitação recebida. Confira seu e-mail.",
            );
          } catch (e) {
            setError(
              e instanceof Error && e.name !== "TimeoutError"
                ? e.message
                : "Não conseguimos confirmar o resultado. Tente novamente com os mesmos dados para conferir, sem criar outro cadastro.",
            );
          } finally {
            lock.current = false;
            setBusy(false);
          }
        })();
      }}
    >
      {[
        {
          name: "name",
          label: "Seu nome",
          type: "text",
          autoComplete: "name",
          max: 150,
        },
        {
          name: "email",
          label: "Seu e-mail",
          type: "email",
          autoComplete: "email",
          max: 200,
        },
        {
          name: "password",
          label: "Crie sua senha",
          type: "password",
          autoComplete: "new-password",
          max: 72,
        },
        {
          name: "confirmPassword",
          label: "Confirme sua senha",
          type: "password",
          autoComplete: "new-password",
          max: 72,
        },
      ].map((field) => (
        <div key={field.name} className="space-y-1.5">
          <Label htmlFor={`register-${field.name}`}>{field.label}</Label>
          <Input
            id={`register-${field.name}`}
            name={field.name}
            type={field.type}
            autoComplete={field.autoComplete}
            maxLength={field.max}
            required
            aria-describedby={error ? "registration-feedback" : undefined}
            disabled={busy}
            className="min-h-11"
          />
        </div>
      ))}
      <p className="text-sm text-slate-600">
        Use pelo menos 8 caracteres, uma letra maiúscula e um número. Sua senha
        não entra no rascunho nem é enviada por e-mail.
      </p>
      <label className="flex items-start gap-3 text-sm">
        <input
          className="mt-1 h-5 w-5 shrink-0"
          name="consent"
          type="checkbox"
          required
          disabled={busy}
        />
        Concordo com o uso dos dados para criar meu acesso e verificar o
        cadastro. Somente uma autorização institucional poderá liberar operações
        da prefeitura.
      </label>
      {error && (
        <p
          role="alert"
          aria-label="Erro no cadastro"
          id="registration-feedback"
          className="break-words text-sm text-red-800"
        >
          {error}
        </p>
      )}
      {message && (
        <p role="status" className="text-sm text-slate-700">
          {message}
        </p>
      )}
      <Button
        type="submit"
        disabled={busy}
        className="min-h-11 w-full whitespace-normal"
      >
        {busy ? "Registrando…" : "Criar conta e verificar e-mail"}
      </Button>
    </form>
  );
}
